import { useMediaQuery, useTheme } from '@mui/material';

import { DESKTOP_MOBILE_CAPTURE_MESSAGE, DocumentUploadSection } from '../../../../../common';
import DiagnosisReportBody from './DiagnosisReportBody';

import type { DiagnosisReportSectionProps } from './types';

export default function DiagnosisReportSection(props: DiagnosisReportSectionProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <DocumentUploadSection
      desktopMobileCaptureMessage={DESKTOP_MOBILE_CAPTURE_MESSAGE}
      disabled={props.disabled}
      radioLabel={isMobile ? 'Submission method' : 'Provide report(s) by'}
      title="Upload diagnosis report"
    >
      <DiagnosisReportBody {...props} />
    </DocumentUploadSection>
  );
}
